import { createGlobalStyle } from "styled-components";

export const PopupAdsGlobalStyle = createGlobalStyle`
  .sunday-component-modal-body {
    cursor: pointer;
  }
`;
